import React from 'react';
import { object, func, bool, string } from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Translation } from 'react-i18next';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import LinearProgress from '@material-ui/core/LinearProgress';

const styles = (theme) => ({
  textFielde: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
    backgroundColor: '#357a38',
    color: '#ffffff',
    fontWeight: '600',
  },
  progress: {
    flexGrow: 1,
  },
});

const ChangePassword = ({
  classes,
  currentPassword = '',
  currentPasswordError = '',
  newPassword = '',
  newPasswordError = '',
  canChangePassword,
  changePassword,
  currentPasswordChanged,
  newPasswordChanged,
  isChangingPassword,
  history,
  changePasswordError = '',
  passwordChanged,
}) => (
  <Translation>
    {(t) => {
      if (passwordChanged) {
        return (
          <Grid container alignItems="center" justifyContent="space-around">
            <Grid item xs={12}>
              <Typography variant="subtitle1" gutterBottom>
                {t('passwordSuccessfullyChanged')}
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/login"
                className={classes.button}
              >
                {t('ok')}
              </Button>
            </Grid>
          </Grid>
        );
      }
      return (
        <form
          onSubmit={(event) => {
            event.preventDefault();
            changePassword();
          }}
        >
          <div>
            <TextField
              id="login-password"
              label={t('password')}
              autoComplete="current-password"
              type="password"
              value={currentPassword}
              onChange={(event) => currentPasswordChanged(event.target.value)}
              className={classes.textField}
              fullWidth
              error={currentPasswordError.length > 0}
              disabled={isChangingPassword}
            />
          </div>
          <div>
            <TextField
              id="confirm-password"
              label={t('confimPassword')}
              autoComplete="current-password"
              type="password"
              value={newPassword}
              onChange={(event) => newPasswordChanged(event.target.value)}
              className={classes.textField}
              fullWidth
              error={newPasswordError.length > 0}
              disabled={isChangingPassword}
            />
          </div>
          {isChangingPassword && (
            <LinearProgress className={classes.progress} />
          )}
          {changePasswordError.length > 0 && (
            <Typography variant="caption" gutterBottom color="error">
              {changePasswordError}
            </Typography>
          )}
          <div>
            <Button
              variant="contained"
              type="submit"
              className={classes.button}
              fullWidth
              disabled={isChangingPassword || !canChangePassword}
            >
              {t('changePassword')}
            </Button>
          </div>
        </form>
      );
    }}
  </Translation>
);

ChangePassword.propTypes = {
  classes: object.isRequired,
  currentPassword: string.isRequired,
  currentPasswordError: string.isRequired,
  newPassword: string.isRequired,
  newPasswordError: string.isRequired,
  changePassword: func.isRequired,
  currentPasswordChanged: func.isRequired,
  newPasswordChanged: func.isRequired,
  isChangingPassword: bool.isRequired,
  canChangePassword: bool.isRequired,
  passwordChanged: bool.isRequired,
  changePasswordError: string,
};

export default withStyles(styles)(ChangePassword);



// WEBPACK FOOTER //
// ./src/view/forms/ChangePassword/ChangePassword.js